/**
 * Stable signature for filter Select options ({ id, value }).
 * Sort keeps API reorder from looking like a change.
 */
export function filterOptionsSignature(items = []) {
    return items
        .map(({ id, value }) => `${id}\0${value ?? ''}`)
        .sort()
        .join('\n')
}

export function filterOptionsEqual(a = [], b = []) {
    if (a === b) {
        return true
    }

    if (a.length !== b.length) {
        return false
    }

    return filterOptionsSignature(a) === filterOptionsSignature(b)
}
